import React from 'react';
import PropTypes from 'prop-types';
import { UserProfile } from '../../calls/ui/components/Common';

const GroupAvatar = ({ participants = [], className = '' }) => {
    const count = participants.length;

    if (count === 0) return null;

    // Layout for 1 participant: just shown as regular circle by caller
    // This component specifically handles 2+ participants

    const renderPart = (p, variantClass) => (
        <div className={`composite-avatar-part ${variantClass}`}>
            <UserProfile userId={p.userId} className="composite-avatar-img" />
        </div>
    );

    if (count === 2) {
        return (
            <div className={`composite-avatar layout-2 ${className}`}>
                {renderPart(participants[0], 'half-left')}
                {renderPart(participants[1], 'half-right')}
            </div>
        );
    }

    if (count === 3) {
        return (
            <div className={`composite-avatar layout-3 ${className}`}>
                {renderPart(participants[0], 'half-left')}
                <div className="half-right-container">
                    {renderPart(participants[1], 'quad-top-right')}
                    {renderPart(participants[2], 'quad-bottom-right')}
                </div>
            </div>
        );
    }

    return (
        <div className={`composite-avatar layout-4 ${className}`}>
            {renderPart(participants[0], 'quad-top-left')}
            {renderPart(participants[1], 'quad-top-right')}
            {renderPart(participants[2], 'quad-bottom-left')}
            {count > 4 ? (
                <div className="composite-avatar-part quad-bottom-right overflow-count">+{count - 3}</div>
            ) : (
                renderPart(participants[3], 'quad-bottom-right')
            )}
        </div>
    );
};

GroupAvatar.propTypes = {
    participants: PropTypes.arrayOf(
        PropTypes.shape({
            userId: PropTypes.string,
            name: PropTypes.string,
            avatarUrl: PropTypes.string,
        }),
    ),
    className: PropTypes.string,
};

export default React.memo(GroupAvatar);
